import PropTypes from "prop-types";
import * as React from "react";
import { PROBLEM, messageFor } from "../../../domain/productComposer/problems";
import { SectionHead, Textarea, TextInput } from "../../../themeV2";
import css from "./sections.module.css";

const NAME_PROBLEMS = new Set([
  PROBLEM.MISSING_NAME,
  PROBLEM.NAME_TOO_LONG,
  PROBLEM.DUPLICATE_NAME,
]);

const DetailsSection = function DetailsSection({
  card,
  problems,
  readOnly,
  showErrors,
  showHeading = true,
  onChange,
}) {
  const nameProblem = problems.find(
    (problem) =>
      problem.cardId === card.cardId && NAME_PROBLEMS.has(problem.code),
  );

  return (
    <section className={css.section}>
      {showHeading && <SectionHead title="Details" as="h3" />}
      <div className={css.fields}>
        <TextInput
          label="Name"
          required
          disabled={readOnly}
          value={card.name}
          onValueChange={(name) => onChange({ name })}
          error={showErrors && nameProblem ? messageFor(nameProblem) : false}
        />
        <Textarea
          label="Description"
          description="Up to 350 characters"
          disabled={readOnly}
          rows={3}
          autoGrow
          value={card.subtext}
          onValueChange={(subtext) =>
            onChange({ subtext: subtext.slice(0, 350) })
          }
        />
      </div>
    </section>
  );
};

DetailsSection.propTypes = {
  showHeading: PropTypes.bool,
  card: PropTypes.shape({
    cardId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    subtext: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  problems: PropTypes.arrayOf(PropTypes.object).isRequired,
  readOnly: PropTypes.bool,
  showErrors: PropTypes.bool,
};

export default DetailsSection;
